export default "__VITE_ASSET__BQ3wop_E__"